import React, { Component, PropTypes } from 'react';
import { Message } from 'sabre-spark-react';
import { search } from './ConfigSearchIndex';
import ReactDOM from 'react-dom';

export default class ConfigSearchProvider extends Component {
    static propTypes = {
        search: PropTypes.string,
        hasAccessConfiguration: PropTypes.object,
        hasAccessTrackingHooks: PropTypes.object
    };
    static defaultProps = {
        search: ''
    };

    constructor(props) {
        super(props);
        this.indexComponent = this.indexComponent.bind(this);
        this.state = {
            indexed: false
        };
    }
    componentDidMount() {
        //indexing check
        this.setState({
            indexed: true
        });
    }

    indexComponent(sectionIndex) {
        return (text, subIndex) => {
            search.addDocument({
                text: text,
                section: subIndex ? [...sectionIndex, ...subIndex] : sectionIndex
            });
        };
    }

    renderTree(searchResults) {
        if (searchResults.length === 0) return [];

        searchResults = searchResults.filter(item => {
            if (item.text.includes('Tracking hooks')) {
                return this.props.hasAccessTrackingHooks.view || this.props.hasAccessTrackingHooks.edit ? true : false;
            } else if (!item.text.includes('Tracking hooks')) {
                return this.props.hasAccessConfiguration.view || this.props.hasAccessConfiguration.edit ? true : false;
            } else {
                return false;
            }
        });

        return searchResults.reduce((acc, v) => {
            acc[v.section[0]] = acc[v.section[0]]
                ? [...acc[v.section[0]], ...v.section.slice(1)]
                : v.section.slice(1) || [];
            return acc;
        }, []);
    }

    render() {
        const searchResults = this.state.indexed ? search.search(this.props.search) : null;
        const renderTree = searchResults ? this.renderTree(searchResults) : null;

        return (
            <div>
                {React.Children.map(
                    renderTree ? renderTree.map((entry, k) => this.props.children[k]) : this.props.children,
                    (child, i) =>
                        child
                            ? React.cloneElement(child, {
                                  onIndex: this.indexComponent([i]),
                                  search: this.props.search,
                                  searchIndex: renderTree ? renderTree[i] : []
                              })
                            : null
                )}
                {!renderTree || renderTree.length === 0 ? (
                    <Message type="info" inline={true} title="No matches found" />
                ) : (
                    ''
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/pages/search/provider/ConfigSearchProvider.js